import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopDto, UpdateShopDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

type UseUpdateShopParams = {
	onSuccess?: (data: ShopDto) => void;
};

export default function useUpdateShop(
	shopId: string,
	options?: UseUpdateShopParams,
) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();

	const invalidateShop = useInvalidateShop(shopId);
	const mutation = $api.useMutation("patch", "/shops/{shopId}");

	return useMutation({
		onSuccess: (data) => {
			invalidateShop();
			successNotification();
			return options?.onSuccess?.(data);
		},
		onError: () => {
			errorNotification();
		},
		mutationFn: async (requestBody: UpdateShopDto) => {
			return mutation.mutateAsync({
				params: { path: { shopId } },
				body: requestBody,
			});
		},
	});
}
